import DefaultLink, { LinkProps as DefaultLinkProps } from 'next/link';
import React from 'react';

export interface LinkProps extends DefaultLinkProps {
  className?: string;
  children?: React.ReactNode;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export const Link = ({ className, children, target, onClick, passHref, ...rest }: LinkProps) => (
  <DefaultLink {...rest} passHref={!!target} className={className} target={target} onClick={onClick} prefetch={false}>
    {children}
  </DefaultLink>
);
